import { render, staticRenderFns } from "./FulfillmentDashboard.vue?vue&type=template&id=7a1185a6"
import script from "./FulfillmentDashboard.vue?vue&type=script&lang=js"
export * from "./FulfillmentDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports